import { secondsToMinutes } from 'date-fns';

export const pickupBufferSecondsToMinutes = (
  seconds: number | null | undefined
) => {
  if (seconds || seconds === 0) return secondsToMinutes(seconds);

  return null;
};
